import { api } from '@spartalabs/pdc-core';

type RegistrarAcessoTelaPayload = {
  rota: string;
  titulo: string;
  funcionalidadeCodigo?: string;
};

const portalAuditoriaApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: builder => ({
    registrarAcessoTela: builder.mutation<{ success: boolean }, RegistrarAcessoTelaPayload>({
      query: body => ({
        url: 'api/PortalAuditoriaPdc/AcessoTela',
        method: 'post',
        data: body,
      }),
    }),
  }),
});

export const useRegistrarAcessoTelaMutation =
  portalAuditoriaApi.useRegistrarAcessoTelaMutation;
